var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirthdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41064 9.66525H20.6066",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1428 3V5.96205",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87131 3V5.96205",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6031 11.6246V8.5993C20.6109 5.89219 18.9684 4.41992 16.3167 4.41992H8.69557C6.05171 4.41992 4.40137 5.89219 4.40137 8.5993V16.7449C4.40137 19.4939 6.05171 21.0002 8.69557 21.0002H10.9142",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45976 13.2823H8.46039",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1375 13.2823H12.1381",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45976 16.673H8.46039",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0279 13.8607L18.8254 15.4562C18.9045 15.6132 19.0565 15.7216 19.2304 15.7469L21.017 16.0032C21.3064 16.0417 21.5105 16.3081 21.472 16.5968C21.4563 16.7153 21.4012 16.8257 21.3147 16.9088L20.0227 18.1498C19.8967 18.2713 19.8374 18.4465 19.8676 18.6197L20.1736 20.3722C20.2205 20.664 20.0216 20.9395 19.7291 20.9871C19.6135 21.0054 19.4959 20.9862 19.3928 20.9314L17.7978 20.1038C17.6405 20.0228 17.4531 20.0228 17.2959 20.1038L15.6998 20.9314C15.4385 21.0702 15.1126 20.971 14.9742 20.7095C14.92 20.6062 14.9002 20.4878 14.919 20.3722L15.224 18.6197C15.2553 18.4475 15.197 18.2713 15.07 18.1498L13.7769 16.9088C13.5676 16.7062 13.5603 16.3719 13.7623 16.1612C13.8456 16.0751 13.9559 16.0194 14.0746 16.0042L15.8612 15.7469C16.0361 15.7225 16.1871 15.6142 16.2662 15.4572L17.0658 13.8607C17.2043 13.5953 17.5302 13.492 17.7957 13.6287C17.8946 13.6803 17.9758 13.7614 18.0279 13.8607Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdate);
export default __webpack_public_path__ + "static/media/Birthdate.56fa8aa81401ea5b2624f567e0302819.svg";
export { ForwardRef as ReactComponent };